import classaction from "./class";
import teacheraction from "./teacher";
export default {
  classaction,
  teacheraction,
};
